/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindStandardsWithCertificateTypesQueryResponse,
  FindStandardsWithCertificateTypesQueryParams,
} from "../types/FindStandardsWithCertificateTypes.ts"

export const findStandardsWithCertificateTypesQueryKey = (
  params: FindStandardsWithCertificateTypesQueryParams
) =>
  [
    { url: "/v1/standard/with-certificate-types" },
    ...(params ? [params] : []),
  ] as const

export type FindStandardsWithCertificateTypesQueryKey = ReturnType<
  typeof findStandardsWithCertificateTypesQueryKey
>

/**
 * @summary Find standards with certificate types
 * {@link /v1/standard/with-certificate-types}
 */
export async function findStandardsWithCertificateTypes(
  params: FindStandardsWithCertificateTypesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindStandardsWithCertificateTypesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/standard/with-certificate-types`,
    params,
    ...requestConfig,
  })
  return res
}

export function findStandardsWithCertificateTypesQueryOptions(
  params: FindStandardsWithCertificateTypesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findStandardsWithCertificateTypesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindStandardsWithCertificateTypesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindStandardsWithCertificateTypesQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findStandardsWithCertificateTypes(params, config)
    },
  })
}

/**
 * @summary Find standards with certificate types
 * {@link /v1/standard/with-certificate-types}
 */
export function useFindStandardsWithCertificateTypes<
  TData = ResponseConfig<FindStandardsWithCertificateTypesQueryResponse>,
  TQueryData = ResponseConfig<FindStandardsWithCertificateTypesQueryResponse>,
  TQueryKey extends QueryKey = FindStandardsWithCertificateTypesQueryKey,
>(
  params: FindStandardsWithCertificateTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindStandardsWithCertificateTypesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findStandardsWithCertificateTypesQueryKey(params)

  const query = useQuery(
    {
      ...findStandardsWithCertificateTypesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
